import { Component, Input } from '@angular/core';
import { SvgIconComponent } from '../../form-elements/components/svg-icon/svg-icon.component';
import { NgClass, NgIf } from '@angular/common';

@Component({
  selector: 'qvs-info-box',
  templateUrl: './info-box.component.html',
  styleUrls: ['./info-box.component.scss'],
  standalone: true,
  imports: [NgClass, NgIf, SvgIconComponent]
})
export class InfoBoxComponent {
  @Input() text: string;
  @Input() title: string;
  @Input() closable = false;
}
